
<div class="wrapper">
  <div class="container-fluid">

    <div class="" style="margin-top: 2px;height:70px;">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Transaction Report Detail</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card-box">

          <form [formGroup]="reportForm" class="form-horizontal" role="form" autocomplete="off">

            <div class="row">
              <div class="form-group" *ngIf="raiseWarning" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                  <ngb-alert type="{{alertType}}" [dismissible]="false" style="width:100%;">
                    <strong></strong> {{message}}
                  </ngb-alert>
                </div>
              </div>
            </div>

            <div class="row g-3">
              <div class="col-md-6" style="min-height:50px;border:0px solid red;">
                <div class="form-group row">

                  <label class="col-2 col-form-label">Report Type<span class="is-mandatory">*</span></label>
                  <div class="col-10">
                    <select class="form-control" formControlName="reportType" (change)="onReportTypeChange()">
                      <option *ngIf="canViewRawReport" value="raw">Transaction report</option>
                      <option *ngIf="canViewReconReport" value="recon">Reconciled transaction report</option>
                      <option *ngIf="canViewGiftCardReport" value="giftcard">Gift card report</option>
                      <option *ngIf="canViewExceptionCardReport" value="exception">Exception switch only report</option>
                      <option *ngIf="canViewQrReport" value="qr">QR transaction report</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-6 row" style="padding:0px;margin:0;">

                    <label class="col-4 col-form-label">Store name<span class="is-mandatory">*</span></label>
                    <div class="col-8">
                      <ng-select2 id="selectedMerchant" formControlName="selectedMerchant"
                                  [data]="merchantsPair" (valueChanged)="onSelectedMerchant($event)"
                                  [options]="select2options"></ng-select2>
                      <ul *ngIf="submitted || this.reportForm.controls['selectedMerchant'].touched"
                          class="parsley-errors-list filled">
                        <li *ngIf="this.reportForm.controls['selectedMerchant'].hasError('required')"
                            class="parsley-required">Merchant is required.</li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-6 row" style="margin:0;">
                    <label class="col-4 col-form-label">Terminal<span class="is-mandatory">*</span></label>
                    <div class="col-8" style="margin:0;">
                      <ng-select2 class="col-md-8" id="selectedTerminal" formControlName="selectedTerminal"
                                  [data]="terminalsPair" [options]="select2options"></ng-select2>
                    </div>
                  </div>
                </div>

                <div class="form-group row">

                  <div class="col-md-6 row" style="padding:0px;margin:0;">
                    <label class="col-4 col-form-label">Start date<span class="is-mandatory">*</span></label>
                    <div class="col-8">
                      <input class="form-control" type="date" name="startDate" formControlName="startDate" />
                      <ul *ngIf="submitted || this.reportForm.controls['startDate'].touched"
                          class="parsley-errors-list filled">
                        <li *ngIf="this.reportForm.controls['startDate'].hasError('required')"
                            class="parsley-required">Start date is required.</li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-6 row" style="margin:0;">
                    <label class="col-4 col-form-label">End date<span class="is-mandatory">*</span></label>
                    <div class="col-8" style="margin:0;padding:0;">
                      <input class="form-control" type="date" name="endDate" formControlName="endDate" />
                      <ul *ngIf="submitted || this.reportForm.controls['endDate'].touched"
                          class="parsley-errors-list filled">
                        <li *ngIf="this.reportForm.controls['endDate'].hasError('required')"
                            class="parsley-required">End date is required.</li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-md-6 ">

                <div class="col-12 row form-group">
                  <h4 class="col-12 add-bt-border" style="border-bottom:thin solid silver;">Additional Filters</h4>
                </div>

                <div class="col-12 row form-group" [formGroup]="dropDownForm">
                  <label class="col-4 col-form-label">Transaction Type</label>
                  <ng-multiselect-dropdown class="col-8"
                                           [settings]="dropdownSettings"
                                           [data]="dropdownList"
                                           formControlName="myItems"
                                           (onSelect)="onItemSelect($event)"
                                           (onSelectAll)="onSelectAll($event)"
                                           (onDeSelect)="onItemDeSelect($event)"
                                           (onDeSelectAll)="onUnSelectAll()">
                  </ng-multiselect-dropdown>

                </div>

                <div class="col-12 row form-group" *ngIf="showCardType">
                  <label class="col-4 col-form-label">Card Type </label>
                  <div class="col-8">
                    <input class="form-control" type="text" formControlName="totalsGroup"
                           placeholder="Enter Card Type" />
                  </div>
                </div>

              </div>

              <div class="col-md-12" style="min-height:20px;border:0px solid red;">
                <div class="row">
                  <label class="col-1 col-form-label"></label>
                  <div class="col-10">
                    <button type="button" class="btn btn-info" (click)="submit()">
                      View {{ getReportTypeName() }}
                    </button>
                    &nbsp;&nbsp;
                    <button type="button" *ngIf="isVisible" class="btn btn-secondary waves-effect waves-light" (click)="resetAll()">
                      Reset
                    </button>
                  </div>
                </div>
              </div>


            </div>

          </form>

          <div class="card-box scroll-box-report" [style.display]="isVisible ? 'block' : 'none'" style="height: 540px; overflow-y: auto; border: 1px solid silver; margin-top:10px;padding:6px;">

            <div id="raw-component-id" *ngIf="reportType === 'raw' || reportType === 'qr'" #contentRaw class="scroll-box-report">
              <raw-transaction-report-component [formatDate]="formatDateTime"
                                                [StartDate]="baseStartDate"
                                                [EndDate]="baseEndDate"
                                                [convertToDecimal]="baseConvertToDecimal">
              </raw-transaction-report-component>
            </div>

            <div id="giftcard-component-id" *ngIf="reportType === 'giftcard'" #contentGiftCard>
              <giftcard-transaction-report-component [formatDate]="formatDateTime"
                                                     [StartDate]="baseStartDate"
                                                     [EndDate]="baseEndDate"
                                                     [convertToDecimal]="baseConvertToDecimal">
              </giftcard-transaction-report-component>
            </div>

            <div id="recon-component-id" *ngIf="reportType === 'recon'" #contentRecon>
              <reconciled-transaction-report-component [formatDate]="formatDateTime"
                                                       [StartDate]="baseStartDate"
                                                       [EndDate]="baseEndDate"
                                                       [convertToDecimal]="baseConvertToDecimal">
              </reconciled-transaction-report-component>
            </div>

            <div id="exception-component-id" *ngIf="reportType === 'exception'" #contenTexceptionCard>
 
              <exception-card-report-component [formatDate]="formatDateTime"
                                               [StartDate]="baseStartDate"
                                               [EndDate]="baseEndDate"
                                               [convertToDecimal]="baseConvertToDecimal">
              </exception-card-report-component>
            </div>

          </div>

          <div class="row" *ngIf="isVisible">
            <label class="col-1 col-form-label"></label>
            <div class="form-group col-md-11" style="width:100%;">

              <div class=" px-6 action-bar" style="display: flex; align-items: center; gap: 10px; ">

                <button type="button"
                        class="btn btn-info waves-effect waves-light"
                        (click)="printTable()">
                  Print <i class="mdi mdi-content-save"></i>
                </button>

                <button type="button"
                        class="btn btn-info waves-effect waves-light"
                        (click)="csvExport()">
                  CSV <i class="mdi mdi-content-save"></i>
                </button>

                <i class="fe-info custom-tooltip" placement="top" tooltipClass="custom-tooltip" style="color: #ff9800; border:thin solid #17a2b8; width:35px;height:35px;display:block;padding:10px;"
                   ngbTooltip="If you do not have an option to save to PDF, try the following. Update Your Browser: Ensure you're using the latest version of your browser. Reset Browser Settings: In Chrome, go to Settings > Advanced > Reset settings to restore default settings. Clear Cache and Cookies: Clearing browsing data can resolve unexpected issues. Try a Different Browser: Test the functionality in another browser to determine if the issue is browser-specific.">
                </i>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
